const initialState = {
    prodDetails: null,
}
function prodDetails(state = initialState, action) {
    switch (action.type) {
        case "PRODUCTDETAILSFROMJSON": {
            // Object.assign(state, {
            //     prodDetailsExp: action.value
            // })
            // return state
            return{...state,prodDetailsExp:action.value}
        } case "OTHERRELATEDVALUE": {
            // Object.assign(state, {
            //     otherValue: action.value
            // })
            // return state
            return{...state,otherValue:action.value}
        } default:
            return state
    }
}
export default prodDetails
